export default "__VITE_ASSET__N8THQCiGQAK_wQXofhkUjg__";